import axios from 'axios';

function getRecaptchaToken() {
  if (sessionStorage.getItem('recaptchaToken')) {
    return sessionStorage.getItem('recaptchaToken');
  } else {
    return null;
  }
}

const service = axios.create({
  baseURL: process.env.baseUrl, //process.env.baseUrl,
  timeout: 40000, // request timeout
  responseType: 'json',
  headers: {
    'Content-Type': 'application/json',
    Pragma: 'no-cache',
    'Cache-Control': 'no-cache,no-store',
    t: Math.round(new Date().getTime() / 1000)
  }
});

service.interceptors.request.use(
  config => {
    // Do something before request is sent
    config.headers.rt = getRecaptchaToken();
    //store.dispatch('changeLoadingStatus', true);
    return config;
  },
  error => {
    //store.dispatch('changeLoadingStatus', false);
    // Do something with request error
    Promise.reject(error);
  }
);

// respone interceptor
service.interceptors.response.use(
  response => {
    //alert(store.getters.session_password);
    /*    if (response.data.error != null) {
      if (
        response.data.error.code === '20005' &&
        response.data.error.sub_code === '2'
      ) {
        store.dispatch('sentApp', {
          action: 'tokenExpired',
          payload: {}
        });
        store.dispatch('changeLoadingStatus', false);
      } else if (
        response.data.error.code === '20005' ||
        response.data.error.code === '10001'
      ) {
        store.dispatch('sentApp', {
          action: 'sessionIsNull',
          payload: {}
        });
        store.dispatch('changeLoadingStatus', false);
        return response.data;
      } else {
        store.dispatch('changeLoadingStatus', false);
        return response.data;
      }
    } else {
      store.dispatch('changeLoadingStatus', false);
      return response.data;
    }*/
    return response.data;
  },
  error => {
    return Promise.reject(error);
  }
);

export default service;
